import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: 'dashboard', label: 'Dashboard' },
  { to: 'engagement', label: 'Engagement' },
  { to: 'tenants', label: 'Tenants' },
  { to: 'security', label: 'Security' },
];

export default function Admin() {
  return (
    <div className="min-h-screen bg-white">
      <div className="border-b border-[#EBEBEB] px-6 pt-4">
        <nav className="flex gap-6">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === 'dashboard'}
              className={({ isActive }) =>
                `pb-3 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? 'border-[#0088FF] text-[#0088FF]'
                    : 'border-transparent text-[#7E7E7E] hover:text-[#1D2739]'
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
